import { render, staticRenderFns } from "./ProductDimensionsWeightUnit.vue?vue&type=template&id=3d7d0928&"
import script from "./ProductDimensionsWeightUnit.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsWeightUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports